// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Other Components
const DocumentCentrePage = () => import('@/modules/document_centre/views/DocumentCentrePage')
const DocumentCentreList = () => import('@/modules/document_centre/views/DocumentCentreList')
const DocumentCentreDetail = () => import('@/modules/document_centre/views/DocumentCentreDetail')
const DocumentCentreHistory = () => import('@/modules/document_centre/views/DocumentCentreHistory')
const DocumentCentreHistoryFiles = () => import('@/modules/document_centre/views/DocumentCentreHistoryFiles')

var routes = [
    {
        path: '/document-centre',
        name: 'DocumentCentre',
        component: DefaultContainer,
        children: [
            {
				path: '/document-centre',
                name: 'DocumentCentreList',
				redirect: '/document-centre/list',
                component: DocumentCentrePage,
                children: [
					{
						path: 'list',
						name: 'DocumentCentreListIndex',
						component: DocumentCentreList,
						meta: {
							tab: 'list',
						},
					},
                    {
						path: 'history',
						name: 'DocumentCentreHistory',
						component: DocumentCentreHistory,
						meta: {
							tab: 'history',
						},
					},
				]
            },
			{
				path: 'list/:documentCentreId',
				name: 'DocumentCentreDetail',
				component: DocumentCentreDetail,
				meta: {
					tab: 'list',
				},
			},
			{
				path: 'history/:documentCentreId',
				name: 'DocumentCentreHistoryFiles',
				component: DocumentCentreHistoryFiles,
				meta: {
					tab: 'history',
				},
			},
        ]
    },
];

export default routes;
